<script>
	import YTSearch from './ytsearch.svelte'

	export let song = {}

	var hoverLink = "";
	function activeLink(link) {
		hoverLink = link;
	}

	function removeLink(link) {
		song.links = song.links.filter(item => item !== link);
	}

	let newLink = "";
	function newLinkKey(e) {
		newLink = newLink.trim();
		if (e.keyCode == 13 && newLink.length > 0) {
			song = song.addLink(newLink);
			newLink = "";
		}
	}

</script>

<ul>
	{#each song.links as link}
		<li>
			<span
				on:mouseover={activeLink(link)}
				on:focus={activeLink(link)}
				on:mouseleave={hoverLink = ""}>
				<a href={link} target="_blank">{link}</a>
				{#if hoverLink === link}
					<span on:click={removeLink(link)} class="trash clickable">&#x1f5d1;</span>
				{/if}
			</span>
		</li>
	{/each}
	<li>
		<input
			bind:value={newLink}
			placeholder="přidat nový odkaz"
			on:keypress={newLinkKey}
		/>
	<li><YTSearch bind:song={song}/>
</ul>
